import {useEffect, useState} from "react";
import moment from "moment/moment";

export default function ArcDigitalClock() {
  const [datetime, setDatetime] = useState<string>(moment().format('YYYY.MM.DD HH:mm'));

  useEffect(() => {
    setInterval(() => {
      if (moment().seconds() === 0) {
        setDatetime(moment().format('YYYY.MM.DD HH:mm'));
      }
    }, 1000)
  }, []);

  return (
    <>{datetime}</>
  );
}